import { Typography } from '@tempmee/react';

/** What a page for one location shows when that location's record fails to load. */
export const LocationLoadError = () => (
  <Typography variant="body1" data-cy="location-load-error">
    We couldn’t load this location. Please try again.
  </Typography>
);
